/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Popover, FormControl, Select, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import LabelledField from "components/labelled-field";
import { LINK_FORMAT_OPTIONS, LINK_STYLE_OPTIONS } from "cms/links/link/helpers";
import { isArrayNotEmpty, isStringNotEmpty } from "utils/empty-exists";

const useStyles = makeStyles(() => ({
    settingsContainer: {
        "& > .MuiPaper-root": {
            marginTop: 12,
            padding: 12,
            width: 280,
            backgroundColor: "#fff",
        },
        "& h5": {
            margin: 0,
            fontSize: "0.875rem",
            lineHeight: 1.5,
            color: "#666",
            fontWeight: 500,
        },
    },
}));

const SettingsDialog = (props) => {
    
    const {
        open,
        anchorEl,
        setAnchorEl,
        settings,
        onSettingsChange,
    } = props;
    const { style, format } = settings || {};
    
    const { t } = useTranslation();
    const classes = useStyles();

    const selectionOptions = LINK_STYLE_OPTIONS;
    const displayOptions = LINK_FORMAT_OPTIONS;

    const onChangeStyle = (event) => {
        const value = event.target.value;
        const updatedValue = isStringNotEmpty(value) ? value : "";
        const nextSettings = { ...settings, style: updatedValue };
        onSettingsChange(nextSettings);
    };

    const onChangeDisplayAs = (event) => {
        const value = event.target.value;
        const updatedValue = isStringNotEmpty(value) ? value : "";
        const nextSettings = { ...settings, format: updatedValue };
        onSettingsChange(nextSettings);
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            placement='top-end'
            className={classes.settingsContainer}
        >
            <h5>{t("commons.linkSettings")}</h5>
            <LabelledField label={t("commons.displayStyle")} className='labelField'>
                {isArrayNotEmpty(selectionOptions) &&
                    <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                        <Select
                            labelId='link-select'
                            id='link-style-select'
                            value={style}
                            fullWidth={true}
                            variant='outlined'
                            onChange={(e) => onChangeStyle(e)}
                        >
                            {style === "" &&
                                <MenuItem value=''>Select...</MenuItem>
                            }
                            {selectionOptions.map((option, index) =>
                                (
                                    <MenuItem
                                        key={index}
                                        value={option?.value}
                                    >
                                        {option?.name}
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </FormControl>
                }
            </LabelledField>
            <LabelledField label={t("commons.displayAs")} className='labelField'>
                {isArrayNotEmpty(displayOptions) &&
                    <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                        <Select
                            labelId='link-select'
                            id='link-style-select'
                            value={format}
                            fullWidth={true}
                            variant='outlined'
                            onChange={(e) => onChangeDisplayAs(e)}
                        >
                            {format === "" &&
                                <MenuItem value=''>Select...</MenuItem>
                            }
                            {displayOptions.map((option, index) =>
                                (
                                    <MenuItem
                                        key={index}
                                        value={option?.value}
                                    >
                                        {option?.name}
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </FormControl>
                }
            </LabelledField>
        </Popover>
    );
};

export default SettingsDialog;
